<template>
  <div class="tallies">
    <div class="vote-container">
      <div class="vote-topper">
        <h4 class="has-text-weight-medium is-marginless">
          Yay
        </h4>
        <p class="heading is-marginless" v-if="pollData.totalVotes.isPositive()">
          {{ parseFloat(pollData.yayVotes.dividedBy(Math.pow(10, 18)).toFixed(2)).toLocaleString() }} kDAO / {{ parseFloat(pollData.totalVotes.dividedBy(Math.pow(10, 18)).toFixed(2)).toLocaleString() }} kDAO
          <span v-if="pollData.totalVotes.isGreaterThan(0)">({{ pollData.yayVotes.dividedBy(pollData.totalVotes).times(100).toFixed(2) }}%)</span>
        </p>
      </div>
      <progress class="progress is-primary is-small" :value="pollData.yayVotes" :max="pollData.totalVotes"></progress>
    </div>
    <div class="vote-container">
      <div class="vote-topper">
        <h4 class="has-text-weight-medium is-marginless">
          Nay
        </h4>
        <p class="heading is-marginless" v-if="pollData.totalVotes.isPositive()">
          {{ parseFloat(pollData.nayVotes.dividedBy(Math.pow(10, 18)).toFixed(2)).toLocaleString() }} kDAO / {{ parseFloat(pollData.totalVotes.dividedBy(Math.pow(10, 18)).toFixed(2)).toLocaleString() }} kDAO
          <span v-if="pollData.totalVotes.isGreaterThan(0)">({{ pollData.nayVotes.dividedBy(pollData.totalVotes).times(100).toFixed(2) }}%)</span>
        </p>
      </div>
      <progress class="progress is-danger is-small" :value="pollData.nayVotes" :max="pollData.totalVotes"></progress>
    </div>
    <div class="vote-container">
      <div class="vote-topper">
        <h4 class="has-text-weight-medium is-marginless">
          Abstain
        </h4>
        <p class="heading is-marginless" v-if="pollData.totalVotes.isPositive()">
          {{ parseFloat(pollData.abstainVotes.dividedBy(Math.pow(10, 18)).toFixed(2)).toLocaleString() }} kDAO / {{ parseFloat(pollData.totalVotes.dividedBy(Math.pow(10, 18)).toFixed(2)).toLocaleString() }} kDAO
          <span v-if="pollData.totalVotes.isGreaterThan(0)">({{ pollData.abstainVotes.dividedBy(pollData.totalVotes).times(100).toFixed(2) }}%)</span>
        </p>
      </div>
      <progress class="progress is-dark is-small" :value="pollData.abstainVotes" :max="pollData.totalVotes"></progress>
    </div>
    <p class="heading">Note: Proposals require a <span class="has-text-weight-bold">{{ $store.daoParameters.governanceParameters.percentageForSuperMajority }}% <a target="_blank" rel="noopener" href="https://en.wikipedia.org/wiki/Supermajority">supermajority</a></span> to pass!</p>
  </div>
</template>

<script>
export default {
  name: 'Tallies',
  props: ['pollData'],
  mounted(){

  },
  components: {

  },
  data(){
    return {
    }
  },
  methods: {

  }
}
</script>

<style type="text/scss" lang="scss">
@import '../assets/sass/globals';
.tallies{
  h3{
    margin-top: 1rem;
  }
  .vote-container{
    &:not(:last-child){
      margin-bottom: 1rem;
    }
    .vote-topper{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
    progress{
      margin-top: .5rem;
    }
  }
}
</style>
